import { theme } from '../../theme/theme'
import { IconProps } from './types'

const DEFAULT_SIZE = 16
const DEFAULT_COLOR = theme.color.black

export const ChatPlus = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6663 11.3333C14.6663 11.687 14.5259 12.0261 14.2758 12.2761C14.0258 12.5262 13.6866 12.6667 13.333 12.6667H4.55167C4.19808 12.6667 3.859 12.8073 3.60901 13.0573L2.14101 14.5253C2.07481 14.5915 1.99048 14.6366 1.89867 14.6548C1.80686 14.6731 1.7117 14.6637 1.62521 14.6279C1.53873 14.5921 1.46481 14.5314 1.4128 14.4536C1.36079 14.3758 1.33302 14.2843 1.33301 14.1907V3.33333C1.33301 2.97971 1.47348 2.64057 1.72353 2.39052C1.97358 2.14048 2.31272 2 2.66634 2H13.333C13.6866 2 14.0258 2.14048 14.2758 2.39052C14.5259 2.64057 14.6663 2.97971 14.6663 3.33333V11.3333Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 5.33398V9.33398" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 7.33398H10" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
